import type { Bonus } from '../types/domain'

/**
 * Chooses the free bet to auto-apply in the classic bet panel: the oldest
 * (FIFO, matching chip placement) claimed free bet that meets the minimum bet,
 * so we never auto-apply one the backend would reject. `freeBets` is expected
 * pre-filtered to claimed bets applicable to the current game, oldest first.
 * `minBetAmount` is in display units (same as `Bonus.amount`).
 */
export function pickClassicAutoApplyFreeBet(
  freeBets: Bonus[],
  minBetAmount?: number
): Bonus | null {
  const usable = freeBets.filter(
    (freeBet) => minBetAmount === undefined || freeBet.amount >= minBetAmount
  )

  return usable[0] ?? null
}
